import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import {
  Ch_generateGeneralAttestationDocumentInput,
  useChGenerateGeneralAttestationDocumentMutation as useChGenerateGeneralAttestationDocumentMutationType,
} from "@/modules/patients/detail/general-attestation/ch/services/__generated__/useChGenerateGeneralAttestationDocumentMutation.graphql"

const mutation = graphql`
  mutation useChGenerateGeneralAttestationDocumentMutation($input: Ch_generateGeneralAttestationDocumentInput!) {
    ch_generateGeneralAttestationDocument(input: $input) {
      ch_GeneralAttestation {
        id
        fileId
        ...chGeneralAttestationsFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useChGenerateGeneralAttestationDocumentMutationType>, "variables"> & {
  params: Ch_generateGeneralAttestationDocumentInput
}

const useChGenerateGeneralAttestationDocumentMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChGenerateGeneralAttestationDocumentMutationType>(
    mutation,
    params,
  )

  const commitHandler = useCallback(
    (config: Config) => {
      commit({
        variables: {
          input: config.params,
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChGenerateGeneralAttestationDocumentMutation }
